import { Button, InputField, KeywordsField } from 'components';
import React, { FC } from 'react';
import { Field, Form } from 'react-final-form';
import { validateRequired } from 'validations';

import './CreatePersonalLeadForm.styles.scss';
import classNames from 'classnames';

type CreatePersonalLeadFormProps = {
  onSubmit: (values: any) => void;
  submitInProgress?: boolean;
};

const CreatePersonalLeadForm: FC<CreatePersonalLeadFormProps> = (props) => {
  const { onSubmit, submitInProgress } = props;

  return (
    <Form
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className="create-contact-form">
          <div className={classNames('create-contact-form__fields', 'form')}>
            <Field
              name="email"
              label="Email *"
              component={InputField}
              placeholder="e.g. john.doe@email.com"
              validate={validateRequired('Email is required.')}
            />

            <Field
              name="first_name"
              label="First name *"
              component={InputField}
              placeholder="e.g. John"
              validate={validateRequired('First name is required.')}
            />

            <Field
              name="last_name"
              label="Last name"
              component={InputField}
              placeholder="e.g. Doe"
            />

            <Field
              name="title"
              label="Job title"
              component={InputField}
              placeholder="e.g. Backend Developer"
            />

            <Field
              name="company_name"
              label="Company name"
              component={InputField}
              placeholder="e.g. Ncoded Solutions"
            />

            <Field
              name="phone"
              label="Phone"
              component={InputField}
              placeholder="e.g. +3816612345"
            />

            <Field
              name="linkedin_url"
              label="LinkedIn URL"
              component={InputField}
              placeholder="Paste LinkedIn profile link"
            />

            <Field
              name="website"
              label="Website"
              component={InputField}
              placeholder="Company or personal website"
            />

            <Field
              name="city"
              label="City"
              component={InputField}
              placeholder="e.g. Belgrade"
            />

            <Field
              name="state"
              label="State"
              component={InputField}
              placeholder="e.g. CA"
            />

            <Field
              name="country"
              label="Country"
              component={InputField}
              placeholder="e.g. Serbia"
            />

            <Field
              name="industry"
              label="Industry"
              component={InputField}
              placeholder="e.g. Software Development"
            />

            <Field name="keywords" label="Keywords" component={KeywordsField} />

            <Field
              name="apollo_id"
              label="Apollo ID"
              component={InputField}
              placeholder="Internal Apollo ID"
            />

            <Field
              name="companyLinkedinUrl"
              label="Company LinkedIn URL"
              component={InputField}
              placeholder="Paste company LinkedIn page link"
            />
          </div>

          <Button
            type="submit"
            className="submit-button"
            isLoading={submitInProgress}
          >
            Create
          </Button>
        </form>
      )}
    />
  );
};

export default CreatePersonalLeadForm;
